import DataWeHave from './DataWeHave';

export default DataWeHave;
